// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Icon/CurrentColor.story.tsx with go/sail-next-tailor-docs-publisher 

import React from 'react';
import { Icon, css, view } from '@sail/ui';
import { mobile } from '@sail/icons/react/DeviceIcon';
const wrapperStyles = css({
  color: 'attention',
  layout: 'row',
  alignY: 'center',
  gap: 'small'
});
export const CurrentColor = () => <view.span uses={[wrapperStyles]}>
    <Icon icon={mobile} /> new messages
  </view.span>;